import React from "react";
import { Popover } from "antd";
import "../css/textWithPopover.css"

/**
 * Utility component to show truncated text with popover (multi-line content)
 */
const TextWithPopover = ({
    text = "",
    length = 40,
    title = "Details",
    maxLines = 4,
    className = "",
}) => {
    const shortText =
        text && text.length > length ? `${text.slice(0, length)}...` : text || "N/A";

    return (
        <Popover
            title={<div className="custom-popover-title">{title}</div>}
            content={
                <div className="custom-popover-content" style={{ "--max-lines": maxLines }}>
                    {text || "No details available"}
                </div>
            }
            trigger="hover"
            overlayClassName="custom-popover-box"
        >
            <span className="description">{shortText}</span>
        </Popover>

    );
};

export default TextWithPopover;
